import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import elementType from 'react-prop-types/lib/elementType';
import SafeAnchor from './SafeAnchor';
import createChainedFunction from './utils/createChainedFunction';
import { PanelContext } from '../Panel/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
class PanelToggle extends React.Component {
  constructor() {
    super(...arguments);
    this.handleToggle = this.handleToggle.bind(this);
  }
  handleToggle(event) {
    const {
      onToggle
    } = this.context || {};
    if (onToggle) {
      onToggle(event);
    }
  }
  render() {
    const {
      onClick,
      className,
      componentClass,
      ...props
    } = this.props;
    const {
      expanded,
      bodyId
    } = this.context || {};
    const Component = componentClass;
    props.onClick = createChainedFunction(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = clsx(className, !expanded && 'collapsed');
    if (bodyId) {
      props['aria-controls'] = bodyId;
    }
    return /*#__PURE__*/_jsx(Component, {
      ...props
    });
  }
}
PanelToggle.defaultProps = {
  componentClass: SafeAnchor
};
PanelToggle.contextType = PanelContext;
export default PanelToggle;